<template>
    <div class="column">
        <div class="advanced-search-card card" :class="{'is-visited': isVisited, 'has-bid': hasBid }">
            <div class="card-content">
                <div class="media">
                    <div class="media-left">
                        <figure class="image is-65x65" @click="openGallery">
                            <img :src="lot.pictures.split('#')[1] + '&h=50'">
                        </figure>
                    </div>
                    <div class="media-content"  @click="goToLotSinglePage" >
                        <div class="subtitle is-6"><b><span class="car-name">{{ lot.company }} {{ lot.model_name_en }} </span> <span class="car-name" v-html="lot.grade_en"></span></b></div>
                        <p class="title is-6"><b>{{ lot.bid }} /</b> {{ lot.model_year_en }} </p>
                        <p class="details"><span v-html="lot.model_type_en"></span>/ {{ lot.displacement_num }} cc / {{ lot.mileage_num * 1000 | formatNumber }} km </p>
                        <p class="details">{{ lot.color_en }} / {{ lot.transmission_en  }} / {{ lot.scores }}</p>
                    </div>
                </div>

                <div class="content ">
                    <a href="#" class="auction"  @click="goToLotSinglePage" >
                        {{ lot.lot_date.split(' ')[1] }}
                        {{ lot.lot_date.split(' ')[0] }}
                        @ {{ lot.auction_name }}</a>
                    <div>Start: ¥{{ lot.start_price * 1000 | formatNumber }} ({{ timeSince(new Date(lot.lot_date)) }}) <span class="result_price">¥{{ lot.end_price * 1000 | formatNumber }}</span> {{ lot.result ? lot.result.toUpperCase()+' ' : '' }} </div>
                </div>
                <footer class="card-footer">

                    <div v-if="bidIsOpen(lot.lot_date)" class="card-footer-item">
                        <button v-if="lot.bids.length > 0" class="button is-small is-info is-outlined" @click="openBidModal">
                            <img src="/static/images/icons/update-bid.png" class="update-bid-icon fontawesome-icon">
                            <span>{{ lot.bids[0].amount_yen * 1000 | formatNumber }}</span>
                        </button>
                        <button class="button is-small is-premium is-outlined" v-else @click="openBidModal">
                            <img src="/static/images/icons/placebid.png" class="place-bid-icon fontawesome-icon">
                            <span>PLACE BID</span>
                        </button>
                    </div>
                    <div v-else class="card-footer-item">
                        <button class="button is-warning is-small is-outlined">
                            <span class="icon is-small">
                                <i class="fas fa-chart-bar"></i>
                            </span>
                            <span>BIDS CLOSED</span>
                        </button>
                    </div>
                    <div class="card-footer-item">
                        <favorite-delete v-if="((this.lot.favorite.length > 0 === true))" :bid="lot"></favorite-delete>
                        <favorite-create v-else :bid="lot"></favorite-create>
                    </div>
                    <div class="card-footer-item">
                        <button @click="openStatisticsModal" class="button is-danger is-small is-outlined">
                            <span class="icon is-small">
                                <i class="fas fa-chart-bar"></i>
                            </span>
                            <span>MARKET PRICE</span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import favoriteCreate from './../../../Card/Buttons/Lots/FavoriteCreate.vue'
    import favoriteDelete from './../../../Card/Buttons/Lots/FavoriteDelete.vue'
    export default {
        components: {
            favoriteCreate,
            favoriteDelete
        },
        props:['lot', 'index'],
        methods: {
            openStatisticsModal() {
                this.$store.dispatch('changeMarketPriceModalSelectedLot', this.lot)
                this.$store.dispatch('changeMarketPriceModalStatus', { status: true, lotId: this.lot.lot_id })
                this.$store.dispatch('fetchMarketPriceModalLots')
            },
            goToLotSinglePage() {
                this.$store.dispatch('setLotToIsVisited', this.lot.lot_id)
                this.$router.push({
                    path: '/single/' + this.lot.lot_id,
                })
            },
            openBidModal() {
                this.$store.dispatch('changeResultBiddingModalStatus', { status: true, lot: this.lot })
                this.$store.dispatch('fetchGroups', {date: this.lot.date})
                this.$store.dispatch('fetchGroupSettings')
                this.$store.dispatch('changeSearchResultActiveLotKey', this.index)
            },
            openGallery() {
                this.$store.dispatch('setResultGalleryItems', this.lot.pictures.split('#'))
                this.$store.dispatch('setResultGalleryOptions', { index: 0 })
                this.$store.dispatch('setResultGalleryStatus', true)
            },
            bidIsOpen(lot_date){
                return true
            },
            timeSince(date){
                var seconds = Math.floor((new Date() - date) / 1000);

                var interval = Math.floor(seconds / 31536000);

                if (interval > 1) {
                    return interval + " years ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " years";
                }
                interval = Math.floor(seconds / 2592000);
                if (interval > 1) {
                    return interval + " months ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " months";
                }
                interval = Math.floor(seconds / 86400);
                if (interval > 1) {
                    return interval + " days ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " days";
                }
                interval = Math.floor(seconds / 3600);
                if (interval > 1) {
                    return interval + " hours ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " hours";
                }
                interval = Math.floor(seconds / 60);
                if (interval > 1) {
                    return interval + " minutes ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " minutes";
                }
                return Math.floor(seconds) + " seconds";
            }
        },
        computed: {
            isVisited() {
                return this.$store.getters.checkIfLotIsVisited(this.lot.lot_id)
            },
            hasBid() {
                return this.lot.bids.length > 0
            }
        }
    }
</script>

<style scoped>
    p {
        max-width: 170px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .auction {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #4a4a4a;
    }

    .car-name {
        overflow: hidden;
        max-width: 100%;
        word-wrap: break-word;
        display: inline-block;
        text-overflow: ellipsis;
    }
    .card-content {
        padding: 10px !important;
    }
    .column {
        padding: 5px !important;
    }
    .image {
        width: 135px;
        cursor: pointer;
    }

    .card-footer-item {
        padding: 2px !important;
    }

    .card-footer-item:not(:last-child) {
        border-right: none !important;
    }

    .card-footer {
        border-top: none !important;
    }

    .title {
        margin-top: 5px !important;
        margin-bottom: 5px !important;
    }

    .subtitle {
        margin-bottom: 5px !important;
    }

    .title:not(.is-spaced)+.subtitle {
         margin-top: 0 !important;
    }

    .details {
        font-size: 12px !important;
        margin-top: 10px;
    }

    .content {
        margin-bottom: 5px !important;
    }

    .card .media:not(:last-child) {
        margin-bottom: 5px !important;
    }

    .is-visited {
        background: #a9ddff !important;
    }
    .has-bid {
        background: #ecd164 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Result/AdvanceSearchResultMobile.vue